import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Handshake, CheckCircle, XCircle, Clock } from "@phosphor-icons/react";
import { PageHeader, Kpi, Segmented } from "@/components/common";
import { api, errMsg, money, fmtDate, fmtDateTime } from "@/lib/api";

const ST = { pending: ["Bekliyor", "text-orange-700", Clock], confirmed: ["Onaylandı", "text-teal-700", CheckCircle], disputed: ["İtiraz", "text-red-700", XCircle] };

export default function Reconciliations() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  useEffect(() => { api.get("/reconciliations").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const shown = status ? rows.filter((r) => r.status === status) : rows;
  const n = (s) => rows.filter((r) => r.status === s).length;
  return (
    <div data-testid="reconciliations-page">
      <PageHeader eyebrow="Cari" title="Mutabakatlar" />
      <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
        <Kpi label="Toplam" value={rows.length} testid="recon-kpi-total" />
        <Kpi label="Bekliyor" value={n("pending")} tone="amber" testid="recon-kpi-pending" delay={40} />
        <Kpi label="Onaylandı" value={n("confirmed")} tone="green" testid="recon-kpi-confirmed" delay={80} />
        <Kpi label="İtiraz" value={n("disputed")} tone="red" testid="recon-kpi-disputed" delay={120} />
      </div>
      <div className="panel p-5">
        <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
          <Segmented value={status} onChange={setStatus} prefix="recon-filter" options={[["", "Tümü"], ["pending", "Bekleyen"], ["confirmed", "Onaylı"], ["disputed", "İtirazlı"]]} />
          <span className="text-xs text-slate-500"><Handshake className="mr-1 inline" />Yanıtsız mektuplara 7 gün sonra otomatik hatırlatma gönderilir.</span>
        </div>
        {shown.length === 0 ? <p className="py-6 text-center text-sm text-slate-500" data-testid="recon-empty">Kayıt yok.</p> : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500"><th className="pb-2">Cari</th><th className="pb-2">Tarih</th><th className="pb-2 text-right">Bakiye</th><th className="pb-2">Durum</th><th className="pb-2">Yanıt / Not</th></tr></thead>
            <tbody>
              {shown.map((r) => { const [l, c, I] = ST[r.status] || ST.pending; return (
                <tr key={r.id} className="border-t align-top" data-testid={`recon-row-${r.id}`}>
                  <td className="py-2 pr-3"><Link to={`/cariler/${r.account_id}`} className="font-semibold hover:underline">{r.account_name}</Link><div className="text-xs text-slate-500">{r.email}</div></td>
                  <td className="py-2 pr-3">{fmtDate(r.as_of)}<div className="text-xs text-slate-500">gönderim {fmtDateTime(r.created_at)}{r.followup_sent_at ? ` · hatırlatma ${fmtDateTime(r.followup_sent_at)}` : ""}</div></td>
                  <td className="py-2 pr-3 text-right font-num">{money(Math.abs(r.balance))}<div className="text-xs text-slate-500">{r.balance >= 0 ? "cari borçlu" : "cari alacaklı"}</div></td>
                  <td className="py-2 pl-4 pr-3"><span className={`inline-flex items-center gap-1 text-xs font-semibold ${c}`} data-testid={`recon-status-${r.id}`}><I weight="fill" /> {l}</span></td>
                  <td className="py-2 text-xs">{r.responded_at ? fmtDateTime(r.responded_at) : "—"}{r.note && <div className="italic text-red-700">“{r.note}”</div>}{r.claimed_balance != null && <div>Beyan: {money(r.claimed_balance)}</div>}</td>
                </tr>); })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
